module.exports = __webpack_public_path__ + "img/湖南地质灾害综合防治信息系统.dec8effe.jpg";